<template>
    <div>
        <Col :xs="2" :sm="2" :md="2" :lg="2" style="margin-right: 10px;">
            <Select v-model="filters.provinceId" @on-change="onRegionChange($event,2)" placeholder="全部省份"
                    clearable="true">
                <Option value="0">全部省份</Option>
                <Option v-for="item in areaList.provinceList" :value="item.id" :key="item.id">{{ item.areaName }}
                </Option>
            </Select>
        </Col>
        <Col :xs="2" :sm="2" :md="2" :lg="2" style="margin-right: 10px;">
            <Select v-model="filters.cityId" @on-change="onRegionChange($event,3)" ref="serSection1" placeholder="全部城市"
                    clearable="true">
                <Option value="0">全部城市</Option>
                <Option v-for="item in areaList.cityList" :value="item.id" :key="item.id">{{ item.areaName }}</Option>
            </Select>
        </Col>
        <Col :xs="2" :sm="2" :md="2" :lg="2" style="margin-right: 10px;">
            <Select v-model="filters.districtId" ref="serSection2" @on-change="onRegionChange($event)"
                    placeholder="全部地区" clearable="true">
                <Option value="0">全部地区</Option>
                <Option v-for="item in areaList.districtList" :value="item.id" :key="item.id">{{ item.areaName }}
                </Option>
            </Select>
        </Col>
    </div>
</template>

<script>
    import {getRegion} from "../service/api.js";

    export default {
        data () {
            return {
                // 地区列表
                areaList: {
                    provinceList: [],
                    cityList: [],
                    districtList: []
                },
                filters: {
                    provinceId: "", //省
                    cityId: "", //市
                    districtId: "" //区，县
                }
            };
        },
        methods: {
            /**
             * 切换选择地区 val: 选取的id type：即将获取的对象类型
             */
            onRegionChange (val, type) {
                let _this = this;
                if (type) {
                    _this.getAreaData(type, val, function (res) {
                        //获取学校列表替代全部
                        _this.getTableData();
                    });
                } else {
                    // 获取学校列表替代全部
                    _this.getTableData();
                }
            },
            /**
             * 获取省市区区域列表
             */
            async getAreaData (type, id, cb) {
                let _this = this;
                if (id != undefined) {
                    await getRegion({
                        type: type,
                        id: id
                    })
                        .then(function (res) {
                            let _data = res;
                            switch (_data.length > 0) {
                                case true:
                                    switch (type) {
                                        case 1:
                                            _this.areaList.provinceList = _data;
                                            _this.$refs.serSection1.clearSingleSelect();
                                            break;
                                        case 2:
                                            _this.areaList.cityList = _data;
                                            _this.$refs.serSection2.clearSingleSelect();
                                            break;
                                        case 3:
                                            _this.areaList.districtList = _data;
                                            break;
                                    }

                                    if (cb) cb(res);
                                    break;
                            }
                        })
                        .catch(function (err) {
                            _this.$Message.error(err.message);
                        });
                }
            },
            // 加载列表获取方法
            getTableData () {
                let _this = this;
                _this.$emit(
                    "query-table-data",
                    _this.filters.provinceId === "0" ? "" : _this.filters.provinceId,
                    _this.filters.cityId === "0" ? "" : _this.filters.cityId,
                    _this.filters.districtId === "0" ? "" : _this.filters.districtId
                );
            }
        },
        mounted () {
            // 加载省份
            this.getAreaData(1, "");
        }
    };
</script>

<style>
    .search-area .ivu-row:after {
        clear : right;
    }
</style>
